<template>
  <div class="a11y-modal">
    <button class="close" @click="closeModal">
      × <span class="sr-only">Close This Dialog</span>
    </button>

    <div class="content">
      <div v-if="loading || !loading" class="loading">
        <font-awesome-icon
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
      </div>
      <h2 class="sr-only">Send us feedback about this dashboard</h2>
      <iframe :src="formUrl" @load="!loading" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'FeedbackModal',

  props: {
    formUrl: {
      type: String,
      default: () => ''
    },

    loading: {
      type: Boolean,
      default: () => true
    }
  },

  methods: {
    closeModal() {
      this.$modal.close();
    }
  }
});
</script>

<style lang="scss">
.v-modal.feedback {
  .v-modal__backdrop {
    background-color: rgba(7, 16, 24, 0.4);
  }

  .v-modal__holder {
    vertical-align: bottom;
  }

  .v-modal__content {
    max-width: 420px;
    margin-right: 0;
    background: transparent;
  }
}
</style>

<style lang="scss" scoped>
.loading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2.5rem;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.a11y-modal {
  min-width: 420px;
  background: #fff;
}

.close {
  position: absolute;
  top: 0;
  right: 0;
  width: 28px;
  height: 28px;
  z-index: 10;
}

.content {
  padding: 0;
}

iframe {
  width: 100%;
  height: 100%;
  min-height: 550px;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}
</style>
